import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PosCreditRequestCompanyContactInformationModalComponent } from './pos-credit-request-company-contact-information-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { PosCreditRequestCompanyContactInformationModalService } from 'src/app/@core/services/pos-credit-request-company-contact-information-modal.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { RequiredAsteriskModule } from 'src/app/@core/directives/required-asterisk/required-asterisk.module';



@NgModule({
  declarations: [PosCreditRequestCompanyContactInformationModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    NgxMaskModule,
    NgSelectModule,
    RequiredAsteriskModule
  ],
  providers: [PosCreditRequestCompanyContactInformationModalService],
  exports: [PosCreditRequestCompanyContactInformationModalComponent]
})
export class PosCreditRequestCompanyContactInformationModalModule { }
